import React, { useState, useEffect } from "react";

import { DatasetDataApi } from "api/DatasetDataApi";
import { DatasetDataInfo } from "models/dataset-models";
import { ScadaTag } from "./ScadaTag";
import { ScadaTagsProps } from "../scadaTypes";

const ScadaTags: React.FC<ScadaTagsProps> = (props) => {
	const [dataMap, setDataMap] = useState<Map<String, DatasetDataInfo>>(
		new Map(),
	);

	useEffect(() => {
		setDataMap(new Map());
		loadData();

		const int = setInterval(loadData, (props.refreshRate ?? 60) * 1000);

		return () => {
			console.log('Cleaning up SCADA refresh interval');
			clearInterval(int);
		};
	}, [props.date]);

    const loadData = () => {
			const chunkSize = 16;
			const tmpMap = dataMap ?? new Map();
			let count = 0;
			const identifiers = props.elements?.map(e => e.identifier);
			if (!identifiers) return;

			while (count < identifiers.length) {
				const chunk = identifiers.slice(count, (count += chunkSize));

				DatasetDataApi.getRecentData(chunk, {refTime: props.date?.toISOString()}).then(
					response => {
						const currentDate = new Date();
						response.data?.forEach(d => {
							tmpMap.set(d.identifier, {
								...d,
								loadedTime: props.date || currentDate,
							} as DatasetDataInfo);
						});

						if (!props.date) {
							props.returnDate(currentDate);
						}

						setDataMap(new Map(tmpMap));
					},
				);
			}
		};

    return (
			<>
				{[...(props.elements ?? [])].map(el => {
					const layer = props.layerOptions.find(g => g.layer === el.layer);
					if (layer && !layer.visible) return;
					const dataset = dataMap.get(el.identifier);

					return (
						<ScadaTag
							key={`${props.id}-${el.identifier}`}
							model={props}
							scadaId={props.id!}
							x={el.xCoord}
							y={el.yCoord}
							dataset={dataset}
							identifier={el.identifier}
							bgColor={el.bgColor}
							fontSize={el.fontSize}
							refTime={props.date}
							parent={props.parent}
							gridSize={props.gridSize}
							onCoordChange={props.onCoordChange}
						/>
					);
				})}
			</>
		);
}

export default ScadaTags;